import { render, staticRenderFns } from "./map-legend.vue?vue&type=template&id=0f64c69a&"
import script from "./map-legend.vue?vue&type=script&lang=js&"
export * from "./map-legend.vue?vue&type=script&lang=js&"
import style0 from "./map-legend.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports